import React from 'react';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer bg-light border-top mt-5 py-4">
      <div className="container text-center">
        <p className="mb-1 text-muted">
          Copyright &copy; {year} <a href="https://amanur.com" className="text-dark font-weight-bold" target="_blank" rel="noopener noreferrer">Amanur Rahman</a>. All rights reserved.
        </p>
        <small className="text-muted">
          Software Engineering Portfolio &bull; <a href="https://amanur.com" target="_blank" rel="noopener noreferrer">amanur.com</a> &bull; <a href="https://project.amanur.com">project.amanur.com</a>
        </small>
      </div>
    </footer>
  );
}

export default Footer;
